import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController,ToastController, IonRadioGroup } from '@ionic/angular';
import { Imgupload } from '../../../../providers/imgupload';
import { GlobalVars } from '../../../../providers/globalVars';
import { ActivatedRoute } from '@angular/router';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-pitemreg',
  templateUrl: './pitemreg.page.html',
  styleUrls: ['./pitemreg.page.scss'],
})
export class PitemregPage implements OnInit {
  @ViewChild('itemstate') itemstate:IonRadioGroup;
  inputPrice = '0';
  initpoint = '0';
  price;
  textCont;
  tagVal = '';
  tagPh = '업체명';
  editTag = false;
  groupVal = '';
  groupPh = '업체 분류';
  editGroup = false;
  titVal = '';
  titPlaceholder = '제목을 입력해 주세요.';
  titedit = false;
  editmode:boolean = false;
  maxByte = 20;
  desc = '';
  type:any = '';
  images:any=[];
  imagethumbs:any=[];
  mindate:any='';
  limit:any='';
  eventend:any='';
  pitemid:any;
  oncechk:boolean = false;

  eatchk:boolean;
  otherchk:boolean;
  advchk:boolean;
  appitemchk:boolean;

  nonechk:boolean = true;
  cairnschk:boolean;
  brisbanechk:boolean;
  //itemstate:any="waiting";
  @ViewChild('priceInput') priceInput;

  constructor(public navCtrl: NavController,private imgupload: Imgupload,private route: ActivatedRoute, 
    public gv: GlobalVars,private toastCtrl: ToastController) { }

  ngOnInit() {
    // console.log(this.itemstate);
    this.pitemid = this.route.snapshot.paramMap.get('id');
    if(this.pitemid)
    {
      firebase.database().ref('/pmall/' + this.pitemid).once('value').then(rst=>{
        let data = rst.val();
        if(data) {
          this.tagVal = data.tag;
          this.groupVal = data.shortinfo;
          this.titVal = data.title;
          this.images = data.images?data.images:[]; // 191216 data.images
          this.imagethumbs = data.imagethumb?data.imagethumb:[]; // 191216 data.imagethumb
          this.desc = data.desc,
          this.initpoint = data.point;
          this.limit = data.limit;
          this.eventend = new Date((data.eventend?data.eventend:null)).toISOString(); //191216 new Date(data.eventend).toISOString();
          // console.log("this.eventend = " + this.eventend);
          this.itemstate.value = data.state;
          if(data.loc)
          {
            for(let i = 0; i < data.loc.split(',').length; i++)
            {
              if(data.loc.split(',')[i] == 'cairns')
              {
                this.cairnschk = true;
                this.nonechk = false;
              }
              else if(data.loc.split(',')[i] == 'brisbane')
              {
                this.brisbanechk = true;
                this.nonechk = false;
              }
            }
          }
          this.type = data.type ? data.type : null;
          this.oncechk = data.once;
          // if(this.type == 'eat') this.eatchk = true;
          // if(this.type == 'other') this.eatchk = true;
          // if(data.adv) this.advchk = true;
          // if(data.appitem) this.appitemchk = true;
          switch(this.type) {
            case 'eat': this.eatchk = true; break;
            case 'other': this.otherchk = true; break;
            case 'adv': this.advchk = true; break;
            case 'appitem': this.appitemchk = true; break;
          }
        }
      })
    }
    var today = new Date();
    if(today.getMonth()+1 < 10)
        this.mindate = today.getFullYear() + '-0' + (today.getMonth()+1);
    else
        this.mindate = today.getFullYear() + '-' + (today.getMonth()+1)
    if(today.getDate() < 10)
        this.mindate += '-0'+today.getDate()
    else
        this.mindate += '-'+today.getDate();
  }

  setVal(form, event) {
    //console.log(event.target);
    if ( form == 'tit' ) {this.titVal = event.target.value; this.titedit = false; console.log(this.titVal);}
    else if( form == 'tag' ) {this.tagVal = event.target.textContent;  this.editTag = false; console.log(this.tagVal);}
    else if( form == 'group') {this.groupVal = event.target.textContent; this.editGroup = false; console.log(this.groupVal);}
  }



  enterInput(event) { // span.tagwrap, span.groupwarp 의 keydown 용도
    const keycode = (event.which) ? event.which : event.keyCode;
    if( keycode == 9 && keycode == 13 ) {
      //console.log(event.target.classList[0]);
      if( event.target.classList[0] == 'tagwrap' ) {
        this.editTag = false;
      } else if( event.target.classList[0] == 'groupwrap' ) {
        this.editGroup = false;
      }
    }
  }



  setEndOfContenteditable(contentEditableElement)
    {
        var range,selection;
        if(document.createRange)//Firefox, Chrome, Opera, Safari, IE 9+
        {
            range = document.createRange();//Create a range (a range is a like the selection but invisible)
            range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
            range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
            selection = window.getSelection();//get the selection object (allows you to change selection)
            selection.removeAllRanges();//remove any selections already made
            selection.addRange(range);//make the range you have just created the visible selection
        }
    }

  charMaxLength(element, event): void {
    // console.log(event);
    const el = event.target;
    const maxLength = el.dataset.maxlength;
    const curLength = el.innerText.length;
    let content = el.innerText;
    // console.log('curLenth = ' + curLength + ' / maxLength = ' + maxLength);

    if( curLength > maxLength ) {
      content = content.substr(0, maxLength);
      event.target.innerText = content;

      this.setEndOfContenteditable( document.getElementById(element) );
    }
  }


  // charMaxByte(maxByte, event){
  //   let oneChar;
  //   let totalByte = 0;
  //   for(var i = 0; i < event.target.value.length; i++) {
  //     oneChar = event.target.value.charAt(i);
  //     if( escape(oneChar).length > 4) {
  //       totalByte += 2;
  //     } else {
  //       totalByte++;
  //     }
  //     if( totalByte <= maxByte) {
  //       len = i + 1;
  //     }
  //   }
  // }


  enterPrice(event): void {
    const keycode = (event.which) ? event.which : event.keyCode;
    //console.log(evt.path[1].nativeElement);
    if (
      (keycode >= 48 && keycode <= 57) || 
      (keycode >= 96 && keycode <= 105)
      ) {
      //console.log("number : " + keycode);
    } else if (
      keycode == 9 ||
      keycode == 8 ||
      (keycode >= 37 && keycode <= 40)
    ) {
      //console.log("tab / delete / arrows");
    } else if (keycode == 190){
      //console.log("dot");
      event.preventDefault();
    } else if (keycode == 13) {
      //console.log("enter");
      event.preventDefault();
      console.log(event);
    } else {
      // console.log("not a number ... " + keycode );
      event.preventDefault();
      this.presentToast('숫자만 입력해 주세요.');
    }
  }

  removeFirstZero(event) {
    const _price = this.priceInput.nativeElement.innerText;
    // console.log("price = " + this.priceInput.nativeElement.innerText);
    // console.log("price[0] = " + this.priceInput.nativeElement.innerText[0]);
    // return this.priceInput.nativeElement.innerText[0].replace(/0/g, '');

    const el = event.target;
    const maxLength = el.dataset.maxlength;
    // const curLength = el.innerText.length;
    let content = el.innerText;
    // console.log('curLenth = ' + curLength + ' / maxLength = ' + maxLength);

    if( _price.length > 1 && _price[0] == "0" ) {
      content = content.substr(1, maxLength);
      event.target.innerText = content;
      this.setEndOfContenteditable( document.getElementById(this.priceInput) );
    }
  }

  removeCommas(num) {
    return num.replace(/,/g, '');
  }

  getPrice(event) {
    this.price = event.target.textContent;
    this.price = this.removeCommas(this.price);
    // this.price = this.price.toFixed(2);
    this.price = Number(this.price);
    this.price = this.price.toLocaleString();
    // return this.price;
    this.inputPrice = this.price;
  }

  removeKor(event) {
    event = event || window.event;
    var keyID = (event.which) ? event.which : event.keyCode;
    //console.log(event.target.value.replace(/[^0-9]/g, ""));
    if (keyID == 8 || keyID == 46 || keyID == 37 || keyID == 39) {
      return;
    } else {
      event.target.textContent = event.target.textContent.replace(/[^0-9\.]/g, "");
    }
  }


  addCommas(event) {
    if( event.target.textContent.indexOf(',') < 1 ) {
      this.price = event.target.textContent;
      this.price = Number(this.price);
      this.price = this.price.toLocaleString();
      return event.target.textContent = this.price;
    } else {
      this.price = event.target.textContent;
      this.price = this.removeCommas(this.price);
      this.price = Number(this.price);
      this.price = this.price.toLocaleString();
      return event.target.textContent = this.price;
    }
  }

  titeditFunc(titinput) {
    if(!this.titedit) {
      this.titedit = true;
      setTimeout(_ => { titinput.setFocus(); }, 50);
    }
  }
  confirmTit(type, event): void {
    if(event.keyCode === 13) {
      if(type == 'tit')
      this.titedit = false;
      else if(type == 'tag')
      this.editTag = false;
      else if(type == 'group')
      this.editGroup = false;
    }
  }



  blurTest(event) {
    console.log(event);
  }

  async htmlupload(fileinput:HTMLInputElement) {
      if(this.images.length > 0 && this.imagethumbs.length > 0 && this.images[0].path && this.imagethumbs[0].path)
        this.imgupload.delete(this.images[0].path, this.imagethumbs[0].path);
      this.images = [];
      this.imagethumbs = [];
      var filelength = fileinput.files.length;
      for(var i = 0; i < filelength; i++)
      {
      var file:File = fileinput.files[i];
      await this.imgupload.readfile(file).then(rst=>
      {
      this.imgupload.imgupload(file, 'pmall')
      .then(imgrst=>{
        this.images.push({path:imgrst[0]['path'], url:imgrst[0]['url']});
        this.imagethumbs.push({path:imgrst[1]['path'], url:imgrst[1]['url']});
      })
      })
      }
  }

  submit(point) {
    let loc = "";
    if (this.cairnschk)
      loc = 'cairns';
    if (this.brisbanechk)
      loc = loc ? loc + ',brisbane' : 'brisbane';
    if (!loc)
      loc = null;
    if(this.eatchk) this.type = 'eat';
    if(this.otherchk) this.type = 'other';
    if(this.advchk) this.type = 'adv';
    if(this.appitemchk) this.type = 'appitem';

    if (this.pitemid) {
      firebase.database().ref('/pmall/' + this.pitemid).update({
        tag: this.tagVal,
        shortinfo: this.groupVal,
        title: this.titVal,
        images: this.images ? this.images : null,
        imagethumb: this.imagethumbs ? this.imagethumbs : null,
        desc: this.desc,
        once: this.oncechk ? this.oncechk : false,
        point: point,
        limit: this.limit,
        eventend: this.eventend ? new Date(this.eventend).getTime() : '',
        type: this.type,
        adv: this.advchk ? this.advchk : null,
        // appitem: this.appitemchk ? this.appitemchk : null,
        loc: loc,
        state: this.itemstate.value
      }).then(_ => {
        this.presentToast('업데이트 되었습니다.');
        this.navCtrl.pop();
      })
    }
    else {
      firebase.database().ref('/pmall').push({
        tag: this.tagVal,
        shortinfo: this.groupVal,
        title: this.titVal,
        images: this.images ? this.images : null,
        imagethumb: this.imagethumbs ? this.imagethumbs : null,
        desc: this.desc,
        once: this.oncechk,
        point: point,
        limit: this.limit,
        eventend: this.eventend ? new Date(this.eventend).getTime() : '',
        sold: 0,
        userId: this.gv.uid,
        createdDate: firebase.database.ServerValue.TIMESTAMP,
        read: 0,
        type: this.type,
        adv: this.advchk ? this.advchk : null,
        loc: loc,
        state: 'waiting'//this.itemstate.value
      }).then(_ => {
        this.presentToastlong('상품이 접수되었습니다.<br>포인트팀에서 확인후 처리해드리겠습니다.');
        this.navCtrl.pop();
      })
    }
  }

  async presentToast(message: string) {
    let toast = await this.toastCtrl.create({
    message: message,
    position: 'bottom',
    duration: 2000
    });
    toast.present();
    }

    async presentToastlong(message: string) {
    let toast = await this.toastCtrl.create({
    message: message,
    position: 'bottom',
    duration: 4000
    });
    toast.present();
    }
}
